import { ComparisonIntensitiesData, ComparisonSignatureData, GenericModelV2, Model, ModelCategory, ModelData } from '../../components/analysis/definitions';

export function instanceOfGenericModelV2Type(object: Model): object is GenericModelV2 {
  return 'data' in object;
}

export function isPassFailModelData(object: ModelData): object is ComparisonIntensitiesData | ComparisonSignatureData {
  return object.type === ModelCategory.ComparisonIntensities || object.type === ModelCategory.ComparisonSignatures;
}
